module.exports = __webpack_public_path__ + "img/palette.4d4d22b.svg";